<template>
  <div class="interface-request-overview">
    <card-header :title="title" />
    <div>
      <chart-interface-request
        v-if="seriesList.length > 0"
        v-bind="$attrs"
        :seriesList="seriesList"
      />
    </div>
  </div>
</template>
<script>
import CardHeader from './card-header.vue';
import ChartInterfaceRequest from './chart-interface-request.vue';

const QuotaList = [
  '#67C23A',
  '#F56C6C',
  '#ffd2bd',
  '#b2edf1',
  '#d0cffa',
  '#cbe0df',
  '#ffe4bd',
  '#f36df9',
  '#5EB0EB',
  '#6E727F',
  '#999A9D',
  '#5EB0EB',
  '#6E727F',
];

export default {
  components: {
    CardHeader,
    ChartInterfaceRequest,
  },
  props: {
    tendencyData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: '接口请求概况',
      seriesList: [],
      labels: [],
      tendencies: [],
      xLineArray: new Array(24)
        .fill(0)
        .map((_item, index) => `${index < 10 ? `0${index}` : `${index}`}:00`),
    };
  },
  watch: {
    tendencyData() {
      this.getChartArray();
    },
  },
  methods: {
    getChartArray() {
      const curHours = new Date().getHours() < 10
        ? `0${new Date().getHours()}:00` : `${new Date().getHours()}:00`;
      const xArray = this.xLineArray;
      const curTime = xArray.indexOf(curHours);

      const { labels = [], tendencies = [] } = this.tendencyData;

      let seriesList = [];
      seriesList = labels.map((label, index) => ({
        name: label,
        type: 'line',
        lineStyle: {
          width: 4,
          type: 'solid', // 'dotted'虚线 'solid'实线
        },
        itemStyle: {
          color: QuotaList[index] ? QuotaList[index] : '',
        },
        smooth: true,

        data: new Array(curTime).fill(0),
      }));
      tendencies.forEach((tendency, index) => {
        if (tendency?.items && tendency?.items?.length) {
          tendency.items?.forEach((item) => {
            seriesList = seriesList.map(((series) => {
              const arr = JSON.parse(JSON.stringify(series.data));
              if (series.name === item.label) {
                arr[index] = item.count;
              }
              return {
                ...series,
                data: arr,
              };
            }));
          });
        }
      });

      if (seriesList.length > 0) {
        this.seriesList = seriesList;
      }
    },
  },
};
</script>
<style lang="scss">
.interface-request-overview {
  flex: 1;
  padding: 10px 14px;
  background-image: url("../../../assets/screen-adapter/最近7天供应商排名统计.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
